
import { AssetPreviewVersionControlController } from './asset-preview-version-control.controller'

function assetPreviewVersionControl () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<',
      contextData: '<',
      previewFlags: '='
    },
    templateUrl: '/core/directives/asset-preview-version-control/asset-preview-version-control.html?$$REVISION$$',
    controller: AssetPreviewVersionControlController
  }
}
export { assetPreviewVersionControl }
